import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ps_label = _resolveComponent("ps-label")!

  return (_openBlock(), _createBlock(_component_ps_label, {
    class: "lg:text-xs sm:text-xxs text-3xs",
    textColor: _ctx.textColor
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["textColor"]))
}